import LoadingPage from 'my-components/LoadingPage';

import StudentCoursePageActivity from '../StudentCoursePageActivity';
import StudentCoursePageNotFound from '../StudentCoursePageNotFound';
import StudentCoursePagePracticeMode from '../StudentCoursePagePracticeMode';
import StudentCoursePageAssesmentPage from './StudentCoursePageAssesmentPage';

export default function StudentCoursePageAssessmentLayout({
  activeComponent,
  assessment,
  classPass,
  course,
  courseSubscription,
  currentUser,
  drawerOpen,
  fetching,
  fetchStatus,
  flashCardDecks,
  onlineCourses,
  onToggleDrawer,
  pathMatchData,
  practiceMode,
  studySessionBundles,
  studySessions,
  subscription,
  userCourse,
}) {
  const commonProps = {
    course,
    currentUser,
    drawerOpen,
    onToggleDrawer,
    studySessions,
  };

  if (!fetching && !assessment) return <StudentCoursePageNotFound {...commonProps} />;

  // an empty content path is the assessment overview, anything else has to resolve
  if (pathMatchData.params['*']) {
    if (fetching) {
      return <LoadingPage />;
    }
    // the path points at content this assessment does not cover
    if (!activeComponent) return <StudentCoursePageNotFound {...commonProps} />;
    const Component = practiceMode ? StudentCoursePagePracticeMode : StudentCoursePageActivity;
    return (
      <Component
        {...commonProps}
        activeComponent={activeComponent}
        assessment={assessment}
        classPassId={classPass?.id}
        fetchStatus={fetchStatus}
        pathMatchData={pathMatchData}
        studySessions={studySessions}
      />
    );
  }
  return (
    <StudentCoursePageAssesmentPage
      {...commonProps}
      assessment={assessment}
      classPassId={classPass?.id}
      courseSubscription={courseSubscription}
      fetching={fetching}
      flashCardDecks={flashCardDecks}
      onlineCourses={onlineCourses}
      studySessionBundles={studySessionBundles}
      studySessions={studySessions}
      subscription={subscription}
      userCourse={userCourse}
    />
  );
}
